module.exports = __webpack_public_path__ + "static/media/check.bdcd334c.svg";